<template>
  <div class="edit-bank-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-width="100px" :rules="rules">
        <el-form-item label="银行名称" prop="bankName">
          <el-input v-model="form.bankName" size="small"></el-input>
        </el-form-item>
        <el-form-item label="银行代号" prop="bankCode">
          <el-input v-model="form.bankCode" size="small"></el-input>
        </el-form-item>
        <el-form-item label="银行标志:" prop="icon">
          <base-upload :cover="form.icon" :action="action" @successCallback="(res)=>successCallback(res, 'icon')" :width="'150px'" :height="'150px'"></base-upload>
        </el-form-item>
        <el-form-item label="银行背景图:" prop="img">
          <base-upload :cover="form.img" :action="action" @successCallback="(res)=>successCallback(res, 'img')" :width="'150px'" :height="'150px'"></base-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm('form')" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '@/api'
import baseConfig from '@/utils/serverUrlConfig'

export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      flag: false,
      id: '',
      // 封面上传地址
      action: baseConfig.baseServerUrl + '/vid/uploadStatic',
      form: {
        bankName: "",
        bankCode: '',
        icon: '',
        img: '',
      },
      // 表单验证规则
      rules: {
        bankName: [
          { required: true, message: '请输入银行名称', trigger: 'blur' },
        ],
        bankCode: [
          { required: true, message: '请输入银行代号', trigger: 'blur' },
        ],
        icon: [{ required: true, message: '请上传银行标志图', trigger: 'blur' }],
        img: [{ required: true, message: '请上传银行背景图', trigger: 'blur' }],
      }
    }
  },
  methods: {
    // 标签封面上传成功回掉
    successCallback(res, type) {
      if (type === 'icon') {
        this.form.icon = res.data.coverImg
      }else {
        this.form.img = res.data.coverImg
      }
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.title === '新增标签') {
            this.addTags()
          } else {
            this.editTag()
          }
        } else {
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.form = {
        bankName: "",
        bankCode: '',
        icon: '',
        img: '',
      }
      this.$refs.form.resetFields()
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑标签'
        this.form.bankName = data.bankName
        this.form.bankCode = data.bankCode
        this.form.icon = data.icon
        this.form.img = data.img
        this.id=data.ID
      } else {
        this.title = '新增标签'
      }
    },
    // 新增栏目
    addTags() {
      API.addCashBank(this.form).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.$emit('handlerTagList')
        } else {
          this.$message.error('添加失败')
        }
        this.handleClose()
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    // 编辑标签
    editTag() {
      let params = Object.assign(this.form, { id: this.id })
      API.editCashBank(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
          this.$emit('handlerTagList')
        } else {
          this.$message.error('编辑失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
  }
}
</script>

<style lang="scss" >
</style>
